import { render, staticRenderFns } from "./AdminView.vue?vue&type=template&id=3be16b0b&scoped=true"
import script from "./AdminView.vue?vue&type=script&lang=js"
export * from "./AdminView.vue?vue&type=script&lang=js"
import style0 from "./AdminView.vue?vue&type=style&index=0&id=3be16b0b&prod&scoped=true&lang=scss"
import style1 from "./AdminView.vue?vue&type=style&index=1&id=3be16b0b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be16b0b",
  null
  
)

export default component.exports